/**
 * The ID of the featured categories section in the content application.
 */
export const FEATURED_CATEGORIES = 'zhgXj6abFVtVzWr7rWfhN';
